"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefinitionType = void 0;
/**
 * Types of definitions, used by Definition type
 */
var DefinitionType;
(function (DefinitionType) {
    /**
     * Boolean type definition, represents a boolean type value
     */
    DefinitionType[DefinitionType["Boolean"] = 0] = "Boolean";
    /**
     * Number type definition, represents a number type value
     */
    DefinitionType[DefinitionType["Number"] = 1] = "Number";
    /**
     * String type definition, represents a string type value
     */
    DefinitionType[DefinitionType["String"] = 2] = "String";
    /**
     * Array type definition, represents an array with a given item type
     */
    DefinitionType[DefinitionType["Array"] = 3] = "Array";
    /**
     * Object type definition, represents an object with the given property types
     */
    DefinitionType[DefinitionType["Object"] = 4] = "Object";
    /**
     * Customize type definition, represents a customized type with a validator function
     */
    DefinitionType[DefinitionType["Customize"] = 5] = "Customize";
})(DefinitionType = exports.DefinitionType || (exports.DefinitionType = {}));
//# sourceMappingURL=DefinitionType.js.map